$(document).ready(function () {
$('br').attr('aria-hidden','true'); 
$('#template--18432921436329__accordion_JbkxaR-tab-1').attr('aria-expanded','true');
$('#template--18432921272489__accordion-tab-1').attr('aria-expanded','true');
$('.divider-svg').attr('aria-hidden','true'); 
});

$(document).ready(function () {
  $('.accordion-tabs').on('click', function () {
    const $button = $(this);
    const expanded = $button.attr('aria-expanded') === 'true';
    $button.attr('aria-expanded', !expanded);

    const $content = $button.next();
    $content.prop('hidden', expanded);
  });
});

 

      // When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function() {
  scrollFunction();
  };
  
  function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
  document.getElementById("back-to-top").style.display = "block";
  } else {
  document.getElementById("back-to-top").style.display = "none";
  }
  }
  
  // When the user clicks on the button, scroll to the top of the document
  document.getElementById("back-to-top").onclick = function() {
  scrollToTop();
  };
  
  function scrollToTop() {
  const scrollStep = -window.scrollY / (500 / 15);
  const scrollInterval = setInterval(function() {
  if (window.scrollY !== 0) {
  window.scrollBy(0, scrollStep);
  } else {
  clearInterval(scrollInterval);
  }
  }, 15);
  }


  
  

  //for menu
 $(document).ready(function($) {
    // Hide submenus initially
    $('.menu-item-has-children > .sub-menu').hide();
    $('.menu-item-has-children > a').attr('aria-expanded', 'false');
  
    // Toggle on click
    $('.menu-item-has-children > a').on('click', function(e) {
      e.preventDefault();
      var $parent = $(this).parent();
      var $submenu = $parent.children('.sub-menu');
      var $link = $(this);
  
      if ($parent.hasClass('open')) {
        $parent.removeClass('open');
        $submenu.slideUp();
        $link.attr('aria-expanded', 'false');
      } else {
        // Optional: close others
        $('.menu-item-has-children').removeClass('open').children('.sub-menu').slideUp();
        $('.menu-item-has-children > a').attr('aria-expanded', 'false');
  
        $parent.addClass('open');
        $submenu.slideDown();
        $link.attr('aria-expanded', 'true');
      }
    });
  
    // Optional: Close on outside click
    $(document).on('click', function(e) {
      if (!$(e.target).closest('.menu-item-has-children').length) {
        $('.menu-item-has-children').removeClass('open').children('.sub-menu').slideUp();
        $('.menu-item-has-children > a').attr('aria-expanded', 'false');
      }
    });
  });

  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      // Close all submenus immediately
      $('.menu-item-has-children').removeClass('open').children('.sub-menu').hide();
      $('.menu-item-has-children > a').attr('aria-expanded', 'false');

      // Focus the last menu link that triggered the menu
      if (lastFocusedMenuLink) {
        lastFocusedMenuLink.focus();
      }
    }
  });

//for tabs
  $(document).ready(function () {
    $('.tabbed-content--tabs.tabs-left button').on('click', function () {
      // Remove 'active' and aria-selected from all buttons
      $('.tabbed-content--tabs.tabs-left button')
        .removeClass('active')
        .attr('aria-selected', 'false');

      // Add 'active' and aria-selected to the clicked button
      $(this)
        .addClass('active')
        .attr('aria-selected', 'true');
    });
  });

  //filters drawer collapsed/expand
  $(document).ready(function () {
    $('.fil-btn').on('click', function () {
      var isExpanded = $(this).attr('aria-expanded') === 'true';
      $(this).attr('aria-expanded', !isExpanded);
      if (isExpanded) {
        $('.list-availability').hide();
      } else {
        $('.list-availability').show();
      }
    });
  });
  
  $(document).ready(function () {
    $('.fil-btn2').on('click', function () {
      var isExpanded = $(this).attr('aria-expanded') === 'true';
      $(this).attr('aria-expanded', !isExpanded);
      if (isExpanded) {
        $('.price_range-price').hide();
      } else {
        $('.price_range-price').show();
      }
    });
  });
  
  //for external links warning
  $(document).ready(function () {
    $('a[href="https://allaboutcookies.org/"], \
       a[href="https://jobs.lever.co/rookcoffee?utm_source=website%20link&utm_medium=employmentpage&utm_campaign=lever"], \
       a[href="https://www.shopify.com/legal/privacy"], \
       a[href="https://policies.google.com/privacy?hl=en"], \
       a[href="https://tools.google.com/dlpage/gaoptout"], \
       a[href="https://www.facebook.com/settings/?tab=ads"], \
       a[href="https://www.google.com/settings/ads/anonymous"], \
       a[href="https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads"], \
       a[href="https://thenai.org/self-regulatory-framework/faq/?tab=2"], \
       a[href="https://optout.aboutads.info/?c=2&lang=EN"]'

    ).each(function () {
      var originalTitle = $(this).text().trim();
      var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) : originalTitle;
      $(this)
        .attr('aria-label', trimmedTitle + ' (opens in a new window)')
        .attr('target', '_blank')
        .removeAttr('title');
    });
  });

  //labels for phone Numbers
  $(document).ready(function() {
    $('a[href="tel:7325089370"],a[href="tel:+17326378936"],[href="tel:+17326378936"],a[href="tel:+1732-252-5838"],a[href="tel:+17324834402"],a[href="tel:+1732-229-7665"],a[href="tel:+17323835681"], a[href="tel:7324905845"],a[href="tel:+18482323604"],a[href="tel:+17322688574"],a[href="tel:+1848-469-8340"],a[href="tel:+732-856-9656"]').each(function() {
        var originalTitle = $(this).text();
        var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) + '' : originalTitle;
        $(this).attr('aria-label', 'Phone Number: ' + trimmedTitle + ' (open in a new window)');
        $(this).attr('target', '_blank');
        $(this).removeAttr('title');
    });
  });

  $(document).ready(function() {
    $('.trime-text').on('click', function() {
      // Remove 'active' from all, then add to clicked
      $('.trime-text').removeClass('active');
      $(this).addClass('active');
   
      // Get clicked item's text
      var activeText = $(this).text().trim();
   
      // Loop through each .trime-texth
      $('.trime-texth').each(function() {
        if ($(this).text().trim() === activeText) {
          $(this).css('display', 'block'); // Show if match
        } else {
          $(this).css('display', 'none');  // Hide if not match
        }
      });
    });
  });
   
  $(document).on("click", "a.trime-text", function (e) {
    e.preventDefault();
  
    // Remove active class and aria-selected from all other tabs
    $("a.trime-text").removeClass("active").attr("aria-selected", "false");
  
    // Add active class to the clicked tab
    $(this).addClass("active");
  
    // Set aria-selected="true" for the active tab
    $(this).attr("aria-selected", "true");
  });

  //for mobile footer dropdwns
  $(document).ready(function() {
    $('.footer-navigation-title.js-footer-navigation-title').click(function() {
      // Get the current state of the aria-expanded attribute
      var isExpanded = $(this).attr('aria-expanded') === 'true';
      
      // Toggle the aria-expanded state
      $(this).attr('aria-expanded', !isExpanded);
  
      // Toggle visibility of the dropdown content
      var contentId = $(this).attr('aria-controls');
      $('#' + contentId).toggle();
  
      // Ensure other dropdowns are closed
      $('.footer-navigation-title.js-footer-navigation-title').not(this).attr('aria-expanded', 'false');
      $('.footer-navigation-content').not('#' + contentId).hide();
    });
  });
  


  $(document).ready(function () {
    const $filterButton = $('#thb-shop-filters');
    const $sideFilters = $('#side-filters');
    const $closeBtn = $('.filter-close-btn');

    // Open the filter sidebar
    $filterButton.on('click', function () {
      $sideFilters.css('display', 'block');
      $sideFilters.attr('aria-hidden', 'false');
      $('.open').addClass('open-cc');
    });

    // Close handler
    function closeSidebar() {
      // Remove focus from filter to prevent screen reader from staying inside
      $sideFilters.find('*').blur();

      $('.open').removeClass('open-cc');
      $sideFilters.css('display', 'none');
      $sideFilters.attr('aria-hidden', 'true');

      // Return focus with delay for accessibility tools
      setTimeout(function () {
        $filterButton.focus();
      }, 500); // shorter timeout is often enough
    }

    // Close on button click
    $closeBtn.on('click', function () {
      closeSidebar();
    });

    // Close on ESC inside filter
    $sideFilters.on('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        closeSidebar();
      }
    });
  }); 

// Mobile Navigation
  $(document).ready(function($) {
    $('a#main-mobile-menu').on('click', function(e) {
      e.preventDefault();
      $('nav#mobile-menu').css('transform','translate(0%, 0px)');
      $('nav#mobile-menu').css('visibility','visible');
      $('nav#mobile-menu').attr('aria-hidden','false');
      setTimeout(function() {
        $('#mobile-menu').focus();
      }, 1000);
    });
  });
 
  $(document).on('click', 'button#close-menu-mobile', function() {
    $('nav#mobile-menu').removeAttr('style').attr('aria-hidden', 'true');
  
    $('.click-capture').remove();
  
    var $target = $('a#main-mobile-menu');
  
    if (!$target.is(':focusable')) {
      $target.attr('tabindex', '-1');
    }
  
    setTimeout(function() {
      $target.focus();
    }, 500);
  });
  
  //for cart focus
 $(document).ready(function () {
  $('#close-btn').on('click', function() {
    $('#quick_cart').focus();
  });
});

//for add to cart
  $(document).ready(function () {
  $('#AddToCart').on('click', function (e) {
    e.preventDefault();
 
    var $form = $(this).closest('form'); // Finds the nearest form related to the product
 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $form.serialize(),
      dataType: 'json',
      success: function () {
        window.location.href = '/cart'; // Redirect to cart after successful add
      },
      error: function () {
        alert('There was an issue adding the product to the cart.');
      }
    });
  });
});
  
////for mobile footer menu
$(document).ready(function () {
  function updateFooterAccessibility() {
    if ($(window).width() <= 768) {
      $('h2.footer-navigation-title.js-footer-navigation-title').each(function () {
        $(this).attr('role', 'button');
        $(this).attr('aria-expanded', 'false');
      });
    } else {
      // Optional: Remove the attributes on desktop if needed
      $('h2.footer-navigation-title.js-footer-navigation-title').each(function () {
        $(this).removeAttr('role').removeAttr('aria-expanded');
      });
    }
  }
 
  // Run on page load
  updateFooterAccessibility();
 
  // Re-run on window resize
  $(window).resize(function () {
    updateFooterAccessibility();
  });
});

// Continue Shoping redirect to back to product
$(document).ready(function() {
  // On add to cart button click
  $('a#AddToCart').on('click', function() {
      var previousPage = window.location.href;
      sessionStorage.setItem('previousPage', previousPage);
  });

  // On continue shopping button click
  $('.proceed-to-checkout .back_to_shop').on('click', function(e) {
      e.preventDefault();
      var previousPage = sessionStorage.getItem('previousPage');
      window.location.href = previousPage || '/collections/all'; 
  });
});

// Slider Next and Previous Button
$(document).ready(function () {
  var $slider = $('.main-slideshow');

  // SVG Icons
  var prevSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="black" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
      <polyline points="15 18 9 12 15 6" />
    </svg>
  `;

  var nextSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="black" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
      <polyline points="9 6 15 12 9 18" />
    </svg>
  `;

  // Create accessible buttons
  var $prevBtn = $('<button>', {
    class: 'slick-custom-prev',
    'aria-label': 'Previous Slide',
    html: prevSVG
  });

  var $nextBtn = $('<button>', {
    class: 'slick-custom-next',
    'aria-label': 'Next Slide',
    html: nextSVG
  });

  // Button styles
  const buttonStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1000,
    backgroundColor: 'white',
    border: '2px solid white',
    borderRadius: '100%',
    padding: '12px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '48px',
    height: '48px'
  };

  $prevBtn.css({...buttonStyle, left: '10px'});
  $nextBtn.css({...buttonStyle, right: '10px'});

  // Inject buttons
  $slider.css('position', 'relative');
  $slider.append($prevBtn, $nextBtn);

  // Add click actions
  $prevBtn.on('click', function () {
    $slider.slick('slickPrev');
  });

  $nextBtn.on('click', function () {
    $slider.slick('slickNext');
  });

  // Keyboard support
  $(document).on('keydown', function (e) {
    if (e.key === 'ArrowLeft') {
      $slider.slick('slickPrev');
    } else if (e.key === 'ArrowRight') {
      $slider.slick('slickNext');
    }
  });
});
